import React from 'react';
import './form.css';
import emailjs from "@emailjs/browser"

function Form() {
  function sendEmail(e) {
    e.preventDefault();

   
    const serviceId = 'service_p8f3lbi';
    const templateId = 'template_9n56j6o';
    const userId = 'WGDifiYIbjOuP1Pjl';

    emailjs.sendForm(serviceId, templateId, e.target, userId)
      .then(
        (result) => {
          console.log(result.text);
          alert('Email sent successfully!');
        },
        (error) => {
          console.log(error.text);
          alert('Error sending email. Please try again later.');
        }
      );
  }

  return (
    <div className='form'>
      <form onSubmit={sendEmail}>
        <label>Your Name</label>
        <input type='text' name='from_name' required />

        <label>Email</label>
        <input type='email' name='from_email' required />

        <label>Subject</label>
        <input type='text' name='subject' required />

        <label>Message</label>
        <textarea rows={6} name='message' placeholder='Type Your Message Here' required />

        <button className='btn' type='submit'>Submit</button>
      </form>
    </div>
  );
}

export default Form;